<template>
    <el-table width="100%" :data="nodes" v-if="dd.length > 0">
        <el-table-column prop="key" label="节点" width="100px"></el-table-column>
        <el-table-column prop="executor_id" label="操作人">
            <template slot-scope="scope">
                <UserSelect :uid = "scope.row.executor_id"  @change="userChange($event,scope.row.key)"></UserSelect>
            </template>
        </el-table-column>
        <el-table-column v-if="activeTab=='trial'" prop="executor_id" label="触发审批前置条件" width="500px">
            <template slot-scope="scope">
                <div>
                    <el-checkbox v-model="scope.row.check_rule.three_times" true-label="1" false-label="0" >同一产品试用=</el-checkbox>
                    <el-input type="number" size="small" v-model="scope.row.check_rule.three_num" style="width:100px;"></el-input>次
                </div>
                <div>
                    <el-checkbox v-model="scope.row.check_rule.more_three_times" true-label="1" false-label="0" >同一产品试用></el-checkbox>
                    <el-input type="number" size="small" v-model="scope.row.check_rule.more_three_num" style="width:100px;"></el-input>次
                </div>
                <div>
                    <el-checkbox v-model="scope.row.check_rule.noce_overtime" true-label="1" false-label="0" >产品单次试用时间超></el-checkbox>
                    <el-input type="number" size="small" v-model="scope.row.check_rule.noce_overtime_day" style="width:100px;"></el-input>天
                </div>
            </template>
        </el-table-column>
        <el-table-column prop="executor_id" label="审批后产品状态" width="500px">
            <template slot-scope="scope">
                <div>
                    审核通过：
                    <el-radio v-model="scope.row.check_rule.check_pass" :label="check_rule_temporary" >产品使用72小时</el-radio>
                    <el-radio v-model="scope.row.check_rule.check_pass" :label="check_rule_permanent" >产品彻底能用</el-radio>
                    <el-radio v-model="scope.row.check_rule.check_pass" :label="check_rule_default" value='0'>不参与</el-radio>
                </div>
                <div>
                    审核不通过：
                    <el-radio v-model="scope.row.check_rule.check_no" :label="check_rule_temporary">产品使用72小时</el-radio>
                    <el-radio v-model="scope.row.check_rule.check_no" :label="check_rule_permanent">产品彻底不能用</el-radio>
                    <el-radio v-model="scope.row.check_rule.check_no" :label="check_rule_default">不参与</el-radio>
                </div>
            </template>
        </el-table-column>
        <el-table-column center label="操作" >
            <template slot-scope="scope">
                <div>
                    <el-button type="text" size="small"  @click="deleteNode(scope.row.key)" >删除</el-button>
                </div>
            </template>
        </el-table-column>
    </el-table>
</template>
<script>
    import UserSelect from "~/widgets/UserSelect.vue";
    export default{
        components: {UserSelect},
        props: {
            nodes: {
                type: Array,
                required: true
            },
            activeTab:{
                required: true
            }
        },
        data() {
            return {
                check_rule_temporary:1,
                check_rule_permanent:2,
                check_rule_default:0,
                radio:'',
                dd: []
            }
        },
        created() {
            this.dd = this.nodes;
        },
        methods:{
            /**
             * 删除节点
             * @param id
             */
            deleteNode(id){
                this.$emit('handleDel', id);
            },
            userChange($event,$key){
                this.$emit('handleUser', $event,$key);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/flow/node.vue